<template>
  <PreLoader v-if="isLoading" />
  <MobileNavbar />
  <SearchModal />
  <router-view />
  <CartModal />
  <BackToUp />
  <WhatsAppChat />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PreLoader from "./components/Layouts/PreLoader.vue";
import MobileNavbar from "./components/Layouts/MobileNavbar.vue";
import SearchModal from "./components/Layouts/SearchModal.vue";
import CartModal from "./components/Layouts/CartModal.vue";
import BackToUp from "./components/Layouts/BackToUp.vue";
import WhatsAppChat from "./components/Layouts/WhatsAppChat.vue";

export default defineComponent({
  name: "App",
  components: {
    PreLoader,
    MobileNavbar,
    SearchModal,
    CartModal,
    BackToUp,
    WhatsAppChat,
  },
  data() {
    return {
      isLoading: true,
    };
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false;
      document.dispatchEvent(new Event("render-event"));
    }, 1000);
  },
});
</script>
